<template>
  <DashboardTemplate :navMenu="true">
    <div class="flex-display js-between ai-center pd-b-3 disabled-on-print">
      <h3 class="mg-y-less text-font-24">
        แก้ไขข้อมูลหลักสูตร {{ getPrefixLabel(prefix) }}{{ nameTh }} {{ lastNameTh }}
      </h3>
    </div>

    <el-tabs v-model="activeName" class="secondary disabled-on-print">
      <el-tab-pane label="หลักสูตรที่ขออนุมัติ" name="1">
        <div v-loading="loading" class="pd-t-4">
          <CourseStatusList
            :showAction="true"
            :statusList="pending"
            @saveStatusCourse="saveStatusCourse"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="หลักสูตรที่อนุมัติแล้ว" name="2"
        ><div v-loading="loading" class="pd-t-4">
          <CourseStatusList
            :showAction="false"
            :statusList="approved"
            @saveStatusCourse="saveStatusCourse"
          /></div
      ></el-tab-pane>
      <el-tab-pane label="หลักสูตรที่ไม่อนุมัติ" name="3"
        ><div v-loading="loading" class="pd-t-4">
          <CourseStatusList
            :showAction="false"
            :showDel="true"
            :statusList="disapproval"
            @saveStatusCourse="saveStatusCourse"
            @delNotAllowCourse="delNotAllowCourse"
          /></div
      ></el-tab-pane>
    </el-tabs>
    <div class="show-only">
      <div class="certificate-print-box">
        <CertificateCard />
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import CourseStatusList from "@/components/course/CourseStatusList";
import { HTTP } from "@/service/axios.js";
import CertificateCard from "@/components/certificate/CertificateCard";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    CourseStatusList,
    CertificateCard,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  data() {
    return {
      pending: [],
      disapproval: [],
      approved: [],
      activeName: "1",
      userId: "",
      loading: true,
      prefix: "",
      nameTh: "",
      lastNameTh:''
    };
  },
  mounted() {
    this.setParams();
    this.fetchStudentsById();
    this.fetchCourseByUser();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        this.userId = this.routeParams.userId;
      }
    },
    fetchCourseByUser() {
      let obj = {
        _id: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`status/course`, obj)
        .then((res) => {
     
          if (res.data.success) {
            this.pending = res.data.obj.pending;
            this.disapproval = res.data.obj.disapproval;
            this.approved = res.data.obj.approved;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCourseByUser error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchStudentsById() {
      let obj = {
        _id: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.prefix = res.data.obj.titleName;
            this.nameTh = res.data.obj.nameTH;
            this.lastNameTh = res.data.obj.surnameTH;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsById error", e);
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
    saveStatusCourse(id, status) {
      this.loading = true;

      let obj = {
        _id: id,
        statusApprove: status,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`status/course`, obj)
        .then((res) => {
          if (res.data.success) {
            this.fetchCourseByUser();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("saveStatusCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    delNotAllowCourse(id) {
      this.loading = true;
      let obj = {
        courseId: id,
        userId: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`withdrawing`, obj)
        .then((res) => {
          if (res.data.success) {
            this.fetchCourseByUser();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delSubject error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>